import React, { MouseEvent, FunctionComponent } from 'react';
import classnames from 'classnames';

import styles from './main.scss';

type DropdownOptionProps = {
    children: React.ReactNode;
    dataTn?: string;
    id?: string;
    isHighlighted?: boolean;
    isSelected?: boolean;
    onClick?: (e: MouseEvent) => void;
    onMouseDown?: () => void;
    onMouseMove?: () => void;
};

export const DropdownOption: FunctionComponent<DropdownOptionProps> = ({
    children,
    dataTn,
    id,
    isHighlighted,
    isSelected,
    onClick,
    onMouseDown,
    onMouseMove,
}) => {
    const className = classnames(styles.option, {
        [styles.optionHighlight]: isHighlighted,
        [styles.optionSelected]: isSelected,
    });
    return (
        <div
            className={className}
            data-tn={dataTn}
            id={id}
            onClick={e => {
                e.preventDefault();
                if (onClick) {
                    onClick(e);
                }
            }}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
        >
            {children}
        </div>
    );
};
